import { cn } from "@/utils/theme";
import type { ComponentProps } from "react";

interface Props {
  children?: React.ReactNode;
}

const Card = ({
  children,
  className,
  ...props
}: Props & ComponentProps<"div">) => {
  return (
    <div
      className={cn(
        "shadow-neutral-xs bg-neutral-object border-[0.5px] border-neutral py-3 px-4 rounded-lg",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;
